// extracted by mini-css-extract-plugin
export default {"Container":"Loading_Container__DHqM4","Message":"Loading_Message__ZAhZt"};